// third party imports
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// internal rebet imports
import "./stylesSider.css";
import {
  ADMIN_OPTIONS,
  CONFIGURATIONS_OPTIONS,
  MARKETING_OPTIONS,
  PROMOTIONS_OPTIONS,
  SIDER_TABS,
  SPORTSBOOK_OPTIONS,
  STAFF_MANAGEMENT_OPTIONS,
  TRANSACTIONS_OPTIONS,
} from "../../../utils/Constants";
import { NAVIGATION_ROUTES } from "../../../utils/NavigationUtils";
import { API_ROUTES } from "../../../api/ApiRoutes";
import { ADMIN_TYPES } from "../../../utils/Constants";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";

// component imports
import SiderTab from "./SiderTab/SiderTab";
import AppContext from "../../../context/AppContext";

// asset imports
import WhiteEventsIcon from "../../../assets/icons/ic_event_white.png";
import GreyEventsIcon from "../../../assets/icons/ic_event_grey.png";
import PromotionsIcon from "../../../assets/icons/ic_promotion.svg";
import StaffManagementIcon from "../../../assets/icons/ic_staff_management.svg";
import DashboardIcon from "../../../assets/icons/ic_dashboard.svg";
import PaymentsIcon from "../../../assets/icons/ic_payments.svg";
import ConfigurationsIcon from "../../../assets/icons/ic_configuration_new.svg";
import ReportsIcon from "../../../assets/icons/ic_reports.svg";
import { PAYMENTS_OPTIONS } from "../../../utils/Constants";
import TransactionsIcon from "../../../assets/icons/ic_transactions.svg";
import UsersIcon from "../../../assets/icons/ic_users.svg";
import LockIcon from "../../../assets/icons/ic_lock.svg";
import LineChartIcon from "../../../assets/icons/ic_line-chart.svg";
import AffiliatesIcon from "../../../assets/icons/ic_affiliates.svg";
import WhiteUsersIcon from "../../../assets/icons/ic_users_white.png";
import GreyUsersIcon from "../../../assets/icons/ic_users_grey.png";
import SportsbookIcon from "../../../assets/icons/ic_sportsbook.svg";
import MarketingIcon from "../../../assets/icons/ic_marketing.svg";
import CasinoIcon from "../../../assets/icons/ic_casino.svg";

const Sider = ({ selectedTab, isExpanded }) => {
  // non-state variables
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const { setSelectedSiderTab, handleWhichDropdownOpen, setWhichDropdownOpen } = useContext(AppContext);

  // state variables
  const [adminType, setAdminType] = useState("");
  const [apiDoneRunning, setAPIDonRunning] = useState(false);

  // use effects
  useEffect(() => {
    getLoggedInAdminsPermissions();
  }, []);

  // api functions
  const getLoggedInAdminsPermissions = async () => {
    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_PERMISSIONS
      );

      setAdminType(response?.data?.data?.group_name);

      setAPIDonRunning(true);
    } catch (error) {
      console.log("error retrieving admins permissions", error?.response);
      setAPIDonRunning(true);
    }
  };

  // helper functions
  const handleUsersPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.USERS);
    navigate(NAVIGATION_ROUTES?.USERS);
    setWhichDropdownOpen([SIDER_TABS?.USERS]);
  };

  const handlePlayersPressed = () => {
    navigate(NAVIGATION_ROUTES?.PLAYERS);
    setWhichDropdownOpen([SIDER_TABS?.PLAYERS]);
  };

  const handleKPIsPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.KPIS);
    navigate(NAVIGATION_ROUTES?.KPIS);
    setWhichDropdownOpen([SIDER_TABS?.KPIS]);
  };

  const handleAdminPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.ADMIN);
    handleWhichDropdownOpen(SIDER_TABS?.ADMIN);
  };

  const handleAffiliatesPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.AFFILIATE);
    navigate(NAVIGATION_ROUTES?.AFFILIATES);
    setWhichDropdownOpen([SIDER_TABS?.AFFILIATE]);
  };

  const handleCodesPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.EVENTS);
    navigate(NAVIGATION_ROUTES?.EVENTS);
    setWhichDropdownOpen([SIDER_TABS?.EVENTS]);
  };

  const handleWhiteListPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.STAFF_MANAGEMENT);
    handleWhichDropdownOpen(SIDER_TABS?.STAFF_MANAGEMENT);
  };

  const handlePaymentsPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.PAYMENTS);
    handleWhichDropdownOpen(SIDER_TABS?.PAYMENTS);
  };

  const handleConfigurationsPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.CONFIGURATIONS);
    handleWhichDropdownOpen(SIDER_TABS?.CONFIGURATIONS);
  };

  const handleMarketingPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.MARKETING);
    handleWhichDropdownOpen(SIDER_TABS?.MARKETING);
  };

  const handleReportsPressed = () => {
    navigate(NAVIGATION_ROUTES?.REPORTS);
    setWhichDropdownOpen([SIDER_TABS?.REPORTS]);
  };

  const handlePromotionsPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.PROMOTIONS);
    handleWhichDropdownOpen(SIDER_TABS?.PROMOTIONS);
  };

  const handleDashboardPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.DASHBOARD);
    navigate(NAVIGATION_ROUTES?.DASHBOARD);
    setWhichDropdownOpen([SIDER_TABS?.DASHBOARD]);
  };
  
  const handleSportsbookPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.SPORTSBOOK);
    handleWhichDropdownOpen(SIDER_TABS?.SPORTSBOOK);
  };
  
  const handleCasinoPressed = () => {
    navigate(NAVIGATION_ROUTES?.CASINO);
    setWhichDropdownOpen([SIDER_TABS?.CASINO]);
  };

  const handleTransactionsPressed = () => {
    setSelectedSiderTab(SIDER_TABS?.TRANSACTIONS);
    handleWhichDropdownOpen(SIDER_TABS?.TRANSACTIONS);
  };

  return (
    <div className={`sider ${isExpanded ? "expanded" : "collapsed"}`}>
      {/* Content for the sider can go here */}

      <div className="sider-buttons">
        {adminType === ADMIN_TYPES?.CUSTOMER_SUPPORT ||
        adminType === ADMIN_TYPES?.SUPER_ADMIN ||
        adminType === ADMIN_TYPES?.COMPLIANCE_AGENT ? (
          <>
            <SiderTab
              selectedIcon={UsersIcon}
              unselectedIcon={UsersIcon}
              tabName={SIDER_TABS?.USERS}
              onPress={handleUsersPressed}
              adminType={adminType}
            />
            {/* <SiderTab
              selectedIcon={WhiteUsersIcon}
              unselectedIcon={GreyUsersIcon}
              tabName={SIDER_TABS?.USERS_NEW}
              onPress={() => {
                setSelectedSiderTab(SIDER_TABS?.USERS_NEW);
                navigate(NAVIGATION_ROUTES?.USERS_NEW);
              }}
            />  */}
          </>
        ) : null}

        {/* {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={DashboardIcon}
            unselectedIcon={DashboardIcon}
            tabName={SIDER_TABS?.DASHBOARD}
            selectedTab={selectedTab}
            onPress={handleDashboardPressed}
          />
        ) : null} */}

        {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={LineChartIcon}
            unselectedIcon={LineChartIcon}
            tabName={SIDER_TABS?.KPIS}
            onPress={handleKPIsPressed}
            adminType={adminType}
          />
        ) : null}

        {/* {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={AffiliatesIcon}
            unselectedIcon={AffiliatesIcon}
            tabName={SIDER_TABS?.AFFILIATE}
            onPress={handleAffiliatesPressed}
          />
        ) : null} */}

        {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={PromotionsIcon}
            unselectedIcon={PromotionsIcon}
            tabName={SIDER_TABS?.PROMOTIONS}
            onPress={handlePromotionsPressed}
            dropdownOptions={PROMOTIONS_OPTIONS}
            adminType={adminType}
          />
        ) : null}

        {/* {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={WhiteEventsIcon}
            unselectedIcon={GreyEventsIcon}
            tabName={SIDER_TABS?.EVENTS}
            onPress={handleCodesPressed}
          />
        ) : null} */}

        {adminType === ADMIN_TYPES?.CUSTOMER_SUPPORT ||
        adminType === ADMIN_TYPES?.SUPER_ADMIN ||
        adminType === ADMIN_TYPES?.COMPLIANCE_AGENT ? (
          <SiderTab
            selectedIcon={StaffManagementIcon}
            unselectedIcon={StaffManagementIcon}
            tabName={SIDER_TABS?.STAFF_MANAGEMENT}
            onPress={handleWhiteListPressed}
            dropdownOptions={STAFF_MANAGEMENT_OPTIONS}
            adminType={adminType}
          />
        ) : null}

        {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={ConfigurationsIcon}
            unselectedIcon={ConfigurationsIcon}
            tabName={SIDER_TABS?.CONFIGURATIONS}
            onPress={handleConfigurationsPressed}
            dropdownOptions={CONFIGURATIONS_OPTIONS}
            adminType={adminType}
            />
        ) : null}

        {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={PaymentsIcon}
            unselectedIcon={PaymentsIcon}
            tabName={SIDER_TABS?.PAYMENTS}
            onPress={handlePaymentsPressed}
            dropdownOptions={PAYMENTS_OPTIONS}
            adminType={adminType}
            />
        ) : null}

        {
          adminType === ADMIN_TYPES?.SUPER_ADMIN ||
          adminType === ADMIN_TYPES?.COMPLIANCE_AGENT ? (
            <SiderTab
              selectedIcon={TransactionsIcon}
              unselectedIcon={TransactionsIcon}
              tabName={SIDER_TABS?.TRANSACTIONS}
              onPress={handleTransactionsPressed}
              dropdownOptions={TRANSACTIONS_OPTIONS}
              adminType={adminType}
            />
        ) : null}

        {adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={SportsbookIcon}
            unselectedIcon={SportsbookIcon}
            tabName={SIDER_TABS?.SPORTSBOOK}
            onPress={handleSportsbookPressed}
            dropdownOptions={SPORTSBOOK_OPTIONS}
            adminType={adminType}
          />
        ) : null}

        {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={ReportsIcon}
            unselectedIcon={ReportsIcon}
            tabName={SIDER_TABS?.REPORTS}
            selectedTab={selectedTab}
            onPress={handleReportsPressed}
            adminType={adminType}
          />
        ) : null}

        {adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={LockIcon}
            unselectedIcon={LockIcon}
            tabName={SIDER_TABS?.ADMIN}
            onPress={handleAdminPressed}
            dropdownOptions={ADMIN_OPTIONS}
            adminType={adminType}
          />
        ) : null}

         {/* {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={CasinoIcon}
            unselectedIcon={CasinoIcon}
            tabName={SIDER_TABS?.CASINO}
            onPress={handleCasinoPressed}
          />
        ) : null}  */}

         {/* {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={MarketingIcon}
            unselectedIcon={MarketingIcon}
            tabName={SIDER_TABS?.MARKETING}
            onPress={handleMarketingPressed}
            dropdownOptions={MARKETING_OPTIONS}
          />
        ) : null}  */}

        {/* {
        adminType === ADMIN_TYPES?.SUPER_ADMIN ? (
          <SiderTab
            selectedIcon={UserListIcon}
            unselectedIcon={UserListIcon}
            tabName={SIDER_TABS?.PLAYERS}
            selectedTab={selectedTab}
            onPress={handlePlayersPressed}
          />
        ) : null} */}

        {/* <SiderTab
        selectedIcon={WhiteSportsboookIcon}
        unselectedIcon={GreySportsbookIcon}
        tabName={SIDER_TABS?.SPORTSBOOK}
        onPress={handleSportsbookPressed}
      /> */}
      </div>
    </div>
  );
};

export default Sider;
